module.exports = __webpack_public_path__ + "media/images/cplook/careerplug_white-0d479ab9cd457bc9182544246db270d2.png";